<template>
	<div>
		<!-- YES/NO -->
		<div v-if='type_of_voting==3' style="display: inline-block; margin-right: 10px">
			<vs-button
				class='mr-2'
				@click="submitVote(1)"
				>{{ $t("Yes") }}
			</vs-button>
			<vs-button
				class='mr-2'
				@click="submitVote(0)"
				>{{ $t("No") }}
			</vs-button>
			<vs-button
				v-if="is_secret"
				class='mr-2'
				@click="submitVote(2)"
			>{{ $t("Abstained") }}
			</vs-button>
		</div>

		<!-- Candidate -->
		<template v-else-if='type_of_voting==1'>
			<table
				v-for='(candidate_, key_) in candidates'
				:key='key_'
				class="candidate-names inline mr-3"
				style="text-align: left !important"
			>
				<tbody>
					<template v-for="(candidate, key) in candidate_">
						<tr :key="key" class='candidate-tr-hover' :class="{'candidate-tr-selected': checkbox.indexOf(candidate.id) > -1 }">
							<td class="float-left">{{ candidate.candidate_name }}</td>
							<td>
								<vs-checkbox
									@change="checkCandidatePreference()"
									:disabled='!(count_checkbox < preference_no.max || checkbox.indexOf(candidate.id) > -1)'
									class="float-right"
									v-model="checkbox"
									:vs-value="candidate.id"
								></vs-checkbox>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
			<div ref='candidate_submit_btn'>
				<vs-button
					:disabled='count_checkbox < preference_no.min'
					@click="submitVote(checkbox)"
					>{{ $t("Submit") }}</vs-button
				>
				<vs-button :disabled='count_checkbox > 0' @click.prevent='specialCandidateButtonhandler(candidate_btn.id)' class="vs-button-primary ml-2" v-for='(candidate_btn,cbi) in candidate_buttons' :key='cbi'>{{ $t(candidate_btn.candidate_name) }}</vs-button>
			</div>
		</template>
		<!-- \Candidate -->

		<!-- Options -->
		<template v-else-if='type_of_voting==2'>
			<table style="text-align: left !important">
				<tbody>
					<tr v-for="(option, key) in options" :key="key">
						<td>
							<div>
								<vs-button
									style="margin-right: 10px; margin-top: 10px"
									@click="submitVote(option)"
								>
									{{ $t(option.options) }}
								</vs-button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</template>
		<!-- /Options -->

		<!-- Free Text -->
		<template v-else-if='type_of_voting==4'>
			<div class="mb-8">
				<template v-for="(candidate) in candidates">
					<div
						class="mb-1"
						:key="candidate.id"
						v-if="candidate.is_checkbox === 1"
					>
						<vs-checkbox
							:disabled="!((freeText_.length + count_checkbox) < preference_no.max || checkbox.indexOf(candidate.candidate_surname + ' ' + candidate.candidate_name) > -1)"
							class="float-left ml-0"
							v-model="checkbox"
							:vs-value="candidate.candidate_surname + ' ' + candidate.candidate_name"
						></vs-checkbox>
						<label>{{
							candidate.candidate_surname + " " + candidate.candidate_name
						}}</label>
					</div>
				</template>

				<template v-for="(candidate, key) in freeText">
						<!-- v-if="key < preference_no.max && ((freeText_.length + checkbox.length) < preference_no || Boolean(freeText[key]))" -->
					<vs-input
						:key='key'
            :label-placeholder="$t('ENTER_SURNAME_NAME_OR_FULL')"
						v-model="freeText[key]"
						autocomplete="off"
						class="w-full"
					></vs-input>
				</template>
			</div>

			<div>
				<br />
				<vs-button @click="submitVote({presentNotVoting:false,payload:checkbox.concat(freeText_)})">
					{{ $t("Submit") }}
				</vs-button>
				<vs-button @click="submitVote({presentNotVoting:true,payload:checkbox.concat(freeText_)})"	class="ml-5">
					{{ $t("NON_PARTICIPATION_INTHE_VOTE") }}
				</vs-button>
			</div>
		</template>
		<!-- Free Text -->

	</div>
</template>

<script>
export default {
	name: 'event-voting-option',
	data: () => ({
		checkbox: [],
		freeText: []
	}),
	computed: {
		freeText_() {
			return this.freeText.filter(ft => ft && ft.trim().length > 0)
		},
    count_checkbox() {
      return this.checkbox.length;
    }
		// freeTextCandidates() {
		// 	return this.type_of_voting==4 ? this.candidates.filter(c => c.is_checkbox !== 1) : [];
		// }
	},
	watch: {
    preference_no: function() {
      this.updateFreeText();
    },
    count_checkbox: function() {
      this.updateFreeText();
    },
	},
	props: {
		is_secret: Boolean,
		type_of_voting: Number,
		candidates: {default: () => [],type:Array},
		candidate_buttons: {default: () => [],type:Array},
		options: {default: () => [],type:Array},
		preference_no: {default: () => ({min:1,max:1}), type:Object}
	},
  created() {
    this.updateFreeText();
  },
	methods: {
    updateFreeText() { 
      const freeText = [];
      const count = this.preference_no.max - this.count_checkbox;
      for(let i = 0; i < count; i++) {
        freeText.push('');
      }
      this.freeText = freeText;
    },
    async submitVote(value) {
      const isOk = await this.$swal({
        title: this.$t('PROMPT_BEFORE_VOTING'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      if(isOk.value)
			  this.$emit('submit-vote', value);
		},
		specialCandidateButtonhandler(id) {
			this.checkbox.push(id);
			this.submitVote(this.checkbox);
		},
		checkCandidatePreference(ev) {
			this.$nextTick(() => {
				if(this.preference_no.max <= this.count_checkbox) {
					// scroll to submit button
					this.$refs['candidate_submit_btn'].scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
				}
			});
		},
	}
}
</script>

<style>
.candidate-names,
.option-names {
	border-collapse: collapse;
	border-spacing: 0;
}

.candidate-names tr:nth-child(even) {
	background-color: #ececec;
}

.option-names tr:nth-child(even) {
	background-color: #ececec;
}

.candidate-names td,
.candidate-result td,
.option-names td {
	margin-bottom: 7px;
	margin-right: 170px;
}

.candidate-tr-selected {
	background-color: rgba(196, 181, 253, 1) !important;
}
.candidate-tr-hover:hover {
	background-color: rgba(196, 181, 253, 1) !important;
}
</style>